export const DEFAULT_OPTION = { label: '', value: '' };
export const EXAMPLE_OPTIONS = [
    { value: 'usd', label: '$ USD' },
    { value: 'eur', label: '€ EUR' },
    { value: 'pln', label: 'zł PLN' },
];
//# sourceMappingURL=RadioButtonMenu.constants.js.map